module.exports = __webpack_public_path__ + "img/D2M3_new.05b975c3.jpg";